
export const setExitCompleteAction = () => {
  return {
    type: 'SET_EXIT_COMPLETE',
    data: true,
  };
};
